// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  z-index: 9999;
  padding: 20px;
}
.error-page .error-box {
  background: white;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 600px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
}
.error-page .error-box .error-icon {
  font-size: 48px;
  margin-bottom: 20px;
}
.error-page .error-box h2 {
  color: #333;
  margin-bottom: 15px;
  font-size: 24px;
  font-weight: 600;
}
.error-page .error-box p {
  color: #666;
  margin-bottom: 20px;
  font-size: 16px;
  line-height: 1.5;
}
.error-page .error-box .error-type {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 6px;
  padding: 12px;
  margin: 15px 0;
  color: #856404;
  font-size: 14px;
  text-align: left;
}
.error-page .error-box .error-details {
  margin: 20px 0;
  text-align: left;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 15px;
}
.error-page .error-box .error-details summary {
  cursor: pointer;
  font-weight: 600;
  color: #495057;
  margin-bottom: 10px;
  outline: none;
}
.error-page .error-box .error-details summary:hover {
  color: #007bff;
}
.error-page .error-box .error-details pre {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  color: #dc3545;
  margin: 10px 0;
}
.error-page .error-box .error-details .stack-trace {
  border-top: 1px solid #dee2e6;
  padding-top: 10px;
  font-size: 11px;
  max-height: 200px;
  overflow-y: auto;
  color: #6c757d;
}
.error-page .error-box .error-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 25px;
}
@media (min-width: 480px) {
  .error-page .error-box .error-buttons {
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }
}
.error-page .error-box .error-button {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
}
.error-page .error-box .error-button.primary {
  background: #007bff;
  color: white;
}
.error-page .error-box .error-button.primary:hover {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}
.error-page .error-box .error-button.secondary {
  background: #28a745;
  color: white;
}
.error-page .error-box .error-button.secondary:hover {
  background: #1e7e34;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}
.error-page .error-box .error-button.tertiary {
  background: #6c757d;
  color: white;
}
.error-page .error-box .error-button.tertiary:hover {
  background: #545b62;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}
.error-page .error-box .error-button:active {
  transform: translateY(0);
}
.error-page .error-box .error-button:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ErrorPage/ErrorPage.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,0BAAA;EACA,aAAA;EACA,aAAA;AACF;AACE;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AACI;EACE,eAAA;EACA,mBAAA;AACN;AAEI;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAAN;AAGI;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AADN;AAII;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAFN;AAKI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAHN;AAKM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AAHR;AAKQ;EACE,cAAA;AAHV;AAOM;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;AALR;AAQM;EACE,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AANR;AAUI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AARN;AAUM;EANF;IAOI,mBAAA;IACA,uBAAA;IACA,eAAA;EAPN;AACF;AAUI;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AARN;AAUM;EACE,mBAAA;EACA,YAAA;AARR;AAUQ;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AARV;AAYM;EACE,mBAAA;EACA,YAAA;AAVR;AAYQ;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AAVV;AAcM;EACE,mBAAA;EACA,YAAA;AAZR;AAcQ;EACE,mBAAA;EACA,2BAAA;EACA,+CAAA;AAZV;AAgBM;EACE,wBAAA;AAdR;AAiBM;EACE,0BAAA;EACA,mBAAA;AAfR","sourcesContent":[".error-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  backdrop-filter: blur(5px);\n  z-index: 9999;\n  padding: 20px;\n\n  .error-box {\n    background: white;\n    padding: 40px 30px;\n    border-radius: 12px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    text-align: center;\n    max-width: 600px;\n    width: 100%;\n    max-height: 80vh;\n    overflow-y: auto;\n\n    .error-icon {\n      font-size: 48px;\n      margin-bottom: 20px;\n    }\n\n    h2 {\n      color: #333;\n      margin-bottom: 15px;\n      font-size: 24px;\n      font-weight: 600;\n    }\n\n    p {\n      color: #666;\n      margin-bottom: 20px;\n      font-size: 16px;\n      line-height: 1.5;\n    }\n\n    .error-type {\n      background: #fff3cd;\n      border: 1px solid #ffeeba;\n      border-radius: 6px;\n      padding: 12px;\n      margin: 15px 0;\n      color: #856404;\n      font-size: 14px;\n      text-align: left;\n    }\n\n    .error-details {\n      margin: 20px 0;\n      text-align: left;\n      background: #f8f9fa;\n      border: 1px solid #e9ecef;\n      border-radius: 6px;\n      padding: 15px;\n\n      summary {\n        cursor: pointer;\n        font-weight: 600;\n        color: #495057;\n        margin-bottom: 10px;\n        outline: none;\n\n        &:hover {\n          color: #007bff;\n        }\n      }\n\n      pre {\n        background: #fff;\n        border: 1px solid #dee2e6;\n        border-radius: 4px;\n        padding: 10px;\n        font-size: 12px;\n        overflow-x: auto;\n        white-space: pre-wrap;\n        word-break: break-word;\n        color: #dc3545;\n        margin: 10px 0;\n      }\n\n      .stack-trace {\n        border-top: 1px solid #dee2e6;\n        padding-top: 10px;\n        font-size: 11px;\n        max-height: 200px;\n        overflow-y: auto;\n        color: #6c757d;\n      }\n    }\n\n    .error-buttons {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      margin-top: 25px;\n\n      @media (min-width: 480px) {\n        flex-direction: row;\n        justify-content: center;\n        flex-wrap: wrap;\n      }\n    }\n\n    .error-button {\n      padding: 12px 24px;\n      border: none;\n      border-radius: 6px;\n      font-size: 16px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      min-width: 140px;\n\n      &.primary {\n        background: #007bff;\n        color: white;\n\n        &:hover {\n          background: #0056b3;\n          transform: translateY(-2px);\n          box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n        }\n      }\n\n      &.secondary {\n        background: #28a745;\n        color: white;\n\n        &:hover {\n          background: #1e7e34;\n          transform: translateY(-2px);\n          box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n        }\n      }\n\n      &.tertiary {\n        background: #6c757d;\n        color: white;\n\n        &:hover {\n          background: #545b62;\n          transform: translateY(-2px);\n          box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);\n        }\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n\n      &:focus {\n        outline: 2px solid #007bff;\n        outline-offset: 2px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
